// Using the browser build that removes the need for node streams (for server rendering)
import styled from "styled-components/dist/styled-components.browser.esm.js";
export default styled;
export * from "styled-components/dist/styled-components.browser.esm.js";
export const __esModule = true;
